import { memo } from 'react';
import { selectPhoneStream } from 'features/sip/sipSlice';
import { RemoteAudio } from 'features/streaming/components/media/remote-stream/RemoteAudio';
import { useAppSelector } from 'store/hooks';
import { selectRemoteStreams } from 'features/streaming/streamingSlice';

export const PhoneAudioStream = memo(() => {
  const phoneStream = useAppSelector(selectPhoneStream);

  const streams = useAppSelector((state) =>
    phoneStream?.feedId
      ? selectRemoteStreams(state, phoneStream.feedId, phoneStream.feedId)
      : undefined
  );

  const audioStream = streams?.find((s) => s.kind === 'audio');

  if (!audioStream?.mid) {
    return null;
  }

  return <RemoteAudio mid={audioStream.mid} />;
});
